export const messages = {
    GOAL_MISSED_OLD_VERSION_CODING_RESULT: `Sorry, you missed some points. You are not eligible.`,
    GOAL_ACHIEVED_OLD_VERSION_CODING_RESULT: (examStatus) => `Congratulations 🎉, you are ${examStatus}.`,
    CONGRATULATIONS: "Congratulations 🎉",
    MAINTENANCE_HEADING: "WE ARE UNDER MAINTENANCE.",
    MAINTENANCE_SUB_HEADING: " We are upgrading our website, we'll be back after 3 hours with new cool features!",
    CONTINUE_WITH_GOOGLE: "Continue with Google",
    GO_TO_EXAM: "Go to exam",
    PRE_MAINTENANCE_ERROR_MSG: "This site is under maintenance. Please Visit after sometime",
    ISA_SIGN_START_ERROR_MSG: "Coming soon",
    PRACTICE: "PRACTICE",
    COMPLETED: "COMPLETED",
    START: "START",
    START_EXAM: "START EXAM",
    VIEW_RESULT: "VIEW RESULT",
    COOKIES_ASSESSMENT_META_DATA: "assessmentMetaData",
    SESSION_ASSESSMENT_META_DATA: "assessmentMetaData",
    COOKIES_INTERVIEW_META_DATA: "interviewMetaData",
    SESSION_INTERVIEW_META_DATA: "interviewMetaData",
    COOKIES_EXAM_META_DATA: "examMetaData",
    SESSION_EXAM_META_DATA: "examMetaData",
    START_INTERVIEW: "START INTERVIEW",
    COOKIES_REPORT_INSIGHTS_META_DATA: "reportInsightsMetaData",
    CORRECTION_ATTEMPT_NUMBER: "correctionAttemptNumber"
};
